import { useLocales } from '@sevenrooms/locales'
import { Button } from '@sevenrooms/ui-kit/form'
import { Icon } from '@sevenrooms/ui-kit/icons'
import { Box } from '@sevenrooms/ui-kit/layout'
import { Text } from '@sevenrooms/ui-kit/typography'
import { reservationWidgetMessages } from '../../../reservationWidgetMessages'

interface ExpandCollapseButtonProps {
  collapsed: boolean
  onClick: (collapsed: boolean) => void
}

export function ExpandCollapseButton({ collapsed, onClick }: ExpandCollapseButtonProps) {
  const { formatMessage } = useLocales()
  return collapsed ? (
    <Button variant="tertiary" size="m" onClick={() => onClick(!collapsed)} noPadding data-test="sr-room-card-show-more-times-button">
      <Text color="primaryFont" textDecoration="underline">
        {formatMessage(reservationWidgetMessages.resWidgetShowMoreTimesButton)}
      </Text>
      <Box ml="s">
        <Icon size="lg" color="primaryFont" name="VMSWeb-chevron-down" />
      </Box>
    </Button>
  ) : (
    <Button variant="tertiary" size="m" onClick={() => onClick(!collapsed)} noPadding data-test="sr-room-card-show-less-times-button">
      <Text color="primaryFont" textDecoration="underline">
        {formatMessage(reservationWidgetMessages.resWidgetShowLessTimesButton)}
      </Text>
      <Box ml="s">
        <Icon size="lg" color="primaryFont" name="VMSWeb-chevron-up" />
      </Box>
    </Button>
  )
}
